<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="问卷名称" prop="name">
                        <el-input v-model="form.name" placeholder="请输入问卷名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="站点选择" prop="siteId">
                        <el-select v-model="form.siteId" placeholder="请选择站点">
                            <el-option v-for="item in countries" :key="item.id" :label="item.siteName"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <div style="margin-left: 120px">
                <el-card v-for="(item, index) in form.questions" :key="index"
                    style="margin-bottom: 10px;position: relative;">
                    <div style="margin-bottom: 20px;">第 {{ index + 1 }} 题</div>
                    <el-button type="text" icon="el-icon-delete"
                        style="position: absolute;right: 10px;top: 10px;color: red" @click="handleDel(item)"></el-button>
                    <el-form-item label="题干">
                        <el-input type="textarea" v-model="item.questionText" placeholder="请输入题干"></el-input>
                    </el-form-item>
                    <el-form-item label="选项">
                        <div v-for="(_, i) in item.optionValues" :key="i" style="margin-bottom: 5px;position: relative">
                            <el-input v-model="item.optionValues[i]"></el-input>
                            <el-button type="text" style="position: absolute;right: 15px;top: 2px;color: red;"
                                icon="el-icon-close" @click="handleDelOption(_, item)"></el-button>
                        </div>
                        <el-button type="text" icon="el-icon-plus" @click="handleAddOption(item)">添加选项</el-button>
                    </el-form-item>
                </el-card>
            </div>
            <div style="display: flex;justify-content: center;margin-top: 30px;">
                <el-button @click="handleAdd">添加题目</el-button>
            </div>
            <el-form-item>
                <div style="display: flex;justify-content: flex-end;">
                    <el-button @click="$router.back()">取消</el-button>
                    <el-button type="primary" @click="handleSave">保存问卷</el-button>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { add, edit, detail } from "@/api/questionnaire";
import { upload } from "@/api/upload";
import { page } from "@/api/site";
import UploaderVideo from "@/components/UploaderVideo.vue";
import UploaderImage from "@/components/UploaderImage.vue";
import Editor from "@/components/Editor.vue";

export default {
    components: { UploaderVideo, UploaderImage, Editor },
    data() {
        return {
            id: null,
            form: {
                name: "",
                siteId: undefined,
                questions: []
            },
            countries: [],
            rules: {
                name: [{ required: true, message: "请输入问卷名称", trigger: "blur" }],
                siteId: [{ required: true, message: "请选择站点", trigger: "change" }]
            }
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        if (this.id) {
            this.getDetail();
        }
        this.getCountryList();
    },
    methods: {
        getCountryList() {
            page({
                pageNum: 1,
                pageSize: 100
            }).then(({ code, data, message }) => {
                if (code == 200) {
                    this.countries = data.records;
                } else {
                    this.$message.error(message);
                }
            })
        },
        getDetail() {
            detail(this.id).then(({ code, data }) => {
                if (code == 200) {
                    this.form = {

                        ...data
                    };
                }
            })
        },
        handleAdd() {
            this.form.questions.push({
                questionText: "",
                optionValues: []
            })
        },
        handleAddOption(item) {
            item.optionValues.push("");

        },
        handleDelOption(option, item) {
            item.optionValues = item.optionValues.filter(o => o != option);
        },
        handleDel(item) {
            this.form.questions = this.form.questions.filter(q => q != item);
        },
        handleBeforeUpload(file) {
            const [, type] = file.type.split("/");
            if (type != "javascript" && type != "json") {
                this.$message.warning("请上传JS文件或JSON文件");
                return;
            }
            upload(file).then(({ code, message, data }) => {
                if (code == 200) {
                    this.form.jsFileUrl = data;
                } else {
                    this.$message.error(message);
                }
            });
            return false;
        },
        handleSave() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                const params = {
                    ...this.form
                }
                if (!this.id) {
                    add(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("添加成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                } else {
                    params.id = this.id;
                    edit(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("修改成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                }
            })
        }
    }
}
</script>

<style></style>